import React, { useState, useEffect } from 'react';
import { Badge } from 'react-bootstrap';

import Table from '../../../facturotopia/table/Table';
import useGlobal from '../../../store';
import UsuarioStatus from './components/UsuarioStatus';

const renderRoles = (item) => {
  return (
    <Badge
      key={item.role}
      variant="info"
    >
      {item.description}
    </Badge>
  );
};

const renderRolesColumn = (item) => {
  return <p>{!!item.roles && item.roles.map(renderRoles)}</p>;
};

const _columns = [
  {
    key: 'nombre',
    title: 'Usuario',
    dataIndex: 'nombre',
  },
  {
    key: 'email',
    title: 'Email',
    dataIndex: 'email',
  },
  {
    key: 'rol',
    title: 'Rol',
    dataIndex: 'rol',
    render: renderRolesColumn,
  },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    render: (item) => {
      return <UsuarioStatus data={item} />;
    },
  },
];

const UsuariosList = (props) => {
  const [meta] = useState({
    columns: _columns,
  });

  const [state, actions] = useGlobal(mapState, mapActions);

  useEffect(() => {
    if (state.data.length === 0) {
      paginate(1);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const paginate = (page = 1) => {
    actions.paginate({
      page,
    });
  };

  const handleOnPageChange = (page) => {
    paginate(page);
  };

  const handleRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    props.onRowSelectionChange({
      selectedRowKeys,
      selectedRows,
    });
  };

  const getRowSelectionConfig = () => {
    return {
      type: 'checkbox',
      onChange: handleRowSelectionChange,
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled Usuario', // Column uration not to be checked
        name: record.name,
      }),
    };
  };

  const getPaginationConfig = () => {
    const { pagination } = state;

    return {
      metadata: pagination,
      onPageChange: handleOnPageChange,
    };
  };

  const { columns } = meta;
  const { data, busy } = state;
  const { onRowClick, selectedRowKeys = [] } = props;

  return (
    <Table
      loading={busy}
      columns={columns}
      rowKey={'id'}
      data={data}
      pagination={getPaginationConfig()}
      rowSelection={{
        selectedRowKeys: selectedRowKeys,
        ...getRowSelectionConfig(),
      }}
      onRowClick={onRowClick}
      onRow={(item) => {
        return {
          className: item.highlight ? 'row-highlighted' : '',
        };
      }}
    ></Table>
  );
};

const mapState = (state) => {
  return state.app.usuarios.list;
};

const mapActions = (actions) => {
  return actions.app.usuarios.list;
};

export default UsuariosList;
